module.exports = __webpack_public_path__ + "img/icon-edit.1d415d9c.svg";